import styled from 'styled-components';
import closeButton from 'src/assets/images/user-mobile/parking/close-button.svg';
import { useNavigate } from 'react-router-dom';

interface HowtoUseProps {
  onClose: () => void;
}

export default function HowtoUse({ onClose }: HowtoUseProps) {
  const navigate = useNavigate();
  return (
    <>
      <ManualContainer>
        <ManualBox>
          <CloseButton onClick={onClose}>
            <img src={closeButton} alt="x" />
          </CloseButton>
          <ManualTitle>
            <p>주차장 관리 페이지</p> 사용안내
          </ManualTitle>
          <OpenButton onClick={() => navigate('/parking/admin/detail')}>
            사용법 확인하기
          </OpenButton>
        </ManualBox>
      </ManualContainer>
    </>
  );
}

const ManualContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 12px 16px 16px 16px;
  margin-bottom: 12px;
`;

const ManualBox = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: 32px;
  border-radius: 24px;
  background: #f4f3f4;
  box-shadow: 0px 2px 2px 0px rgba(17, 17, 17, 0.08);
`;
const CloseButton = styled.div`
  display: flex;
  justify-content: flex-end;
  img {
    margin: 16px 20px 0 0;
  }
`;
const ManualTitle = styled.div`
  color: var(--Font-02_black, #111);
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
  letter-spacing: -0.6px;

  margin-bottom: 20px;
`;
const OpenButton = styled.button`
  display: flex;
  margin: 0 auto;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 16px;
  background: #111;

  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.4px;
`;
